import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigProvider } from '../../providers/config/config';

import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
//import { File } from '@ionic-native/file';

import { Message, HousingUnit, User, Condominium, MessageVisibility, MessageReceiverType, MessagePriority, DomainEvents, MessageVisibleNotification, NotificationId, MessageType } from '../../models/models';
import { AuthProvider } from '../auth/auth';
import { Events } from 'ionic-angular';
import { DeviceProvider } from '../device/device';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { Badge } from '@ionic-native/badge';
import { Observable } from 'rxjs/Observable';
//import { FlavourProvider } from '../flavour/flavour';


declare var window;

@Injectable()
export class MessageProvider {
	/*
	Id timeout polling messaggi, se !=null il polling è attivo
	*/
	private authMessagesPollTimeout: number = null;

	private visibleMessageCount = 0;

	/**
	Restituisce il tempo intermedio tra un poll e il successivo in ms, che può variare in funzione  dello stato del sistema, es. schermo acceso o spento
	*/
	private get authMessagesPollTime(): number {
		let time: number = null;
		if (this.devices.isInBackground) {//Se l'app in background il tempo di polling diminuisce
			//console.log('App in background, tempo di polling: ' + ConfigProvider.INTERVAL_USER_MESSAGE_POLLING_BACKGROUND);
			time = ConfigProvider.INTERVAL_USER_MESSAGE_POLLING_BACKGROUND;
		} else {
			//console.log('App in primo piano, tempo di polling: ' + ConfigProvider.INTERVAL_USER_MESSAGE_POLLING_FOREGROUND);
			time = ConfigProvider.INTERVAL_USER_MESSAGE_POLLING_FOREGROUND;
		}

		time *= 1000;

		//console.log('Tempo di polling usato: ' + time + 'ms');
		return time;
	}
	constructor(
		private auth: AuthProvider,
		private badge: Badge,
		private devices: DeviceProvider,
		private events: Events,
		//private file: File,
		private fileTransfer: FileTransfer,
		//private flavours: FlavourProvider,
		private http: HttpClient,
		private localNotifications: LocalNotifications
		//private nav: NavController
	) {
		let self = this;


		//TODO Spostare le notifiche in un apposito privder che raccolga messaggi da tutti gli emittenti
		self.events.subscribe(DomainEvents.USER_LOGIN, (_user: User, _time) => {//permesso per poi inviare le notifiche messaggi
			console.group('[MessageProvider.events.on(MESSAGE_VISIBLE_NOTIFICATION)] Ricevuta notifica di login')
			self.localNotifications.requestPermission()
			self.badge.requestPermission()
		});

		self.events.subscribe(DomainEvents.USER_LOGOUT, (_user: User, _time) => {//permesso per poi inviare le notifiche messaggi
			self.localNotifications.clearAll();
		});

		self.badge.clear()
		self.localNotifications.clear(NotificationId.MESSAGE_VISIBLE_NOTIFICATION)//elimina eventuali notifiche

		self.events.subscribe(DomainEvents.MESSAGE_VISIBLE_NOTIFICATION, (visibles: MessageVisibleNotification) => {
			//TODO: Caricare tutti i messaggi utente aggiornando il suo elenco messaggi, oppure gli ultimi N non eliminati
			console.group('[MessageProvider.events.on(MESSAGE_VISIBLE_NOTIFICATION)] Aggiornamento messaggi visibili')

			if (visibles.count === self.visibleMessageCount) {//Prevenzione notifiche multiple
				console.debug('Questi messaggi visibili sono già stati notificati, non eseguo ulteriori azioni')
				return;
			}

			self.visibleMessageCount = visibles.count;


			if (self.devices.isBrowser)/*self.platform.is('core') || self.platform.is('mobileweb')*/ {
				console.debug('[MessageProvider.events.on(MessageVisibleNotification)] Browser: Uso le notifiche browser')
				if (!visibles.count) {
					return;
				}

				// Let's check if the browser supports notifications
				if (!("Notification" in window)) {
					console.warn("Questo browser non supporta le notifiche");
				}

				Notification.requestPermission().then(_result => {
					try {
						let title = ConfigProvider.APPLICATION_NAME + ': ' + visibles.count + ' ' + ((visibles.count > 1) ? 'messaggi' : 'messaggio');
						var options = {
							//body: body,
							//icon: icon
						};
						var n = new Notification(title, options);
						n.onclick = _event => {
							//Va al pannello di controllo
							//self.nav.goToRoot({});//Torna alla root attualmente configurata
							//self.devices.moveToForeground()
						};
					} catch (e) {
						console.error('Errore attivando la notifica', e);
					}
				});
			} else {
				console.debug('[MessageProvider.events.on(MessageVisibleNotification)] App: uso le notifiche native')

				if (!visibles.count) {
					self.badge.clear()
					self.localNotifications.clear(NotificationId.MESSAGE_VISIBLE_NOTIFICATION)//elimina eventuali notifiche
				} else {
					//badge conteggio
					self.badge.requestPermission().then(can => {
						if (can) {
							self.badge.set(visibles.count)
						}
					})

					//notifica messaggi
					self.localNotifications.requestPermission().then(can => {
						if (can) {
							self.localNotifications.schedule({
								//channel: ConfigProvider.NOTIFICATION_CHANNEL_UNREADMESSAGE,
								//group: groupName,//raggruppa se hanno lo stesso id
								//groupSummary: true,
								//summary: ConfigProvider.APPLICATION_NAME + ': ' + unreads.count + ' ' + ((unreads.count > 1) ? 'messaggi' : 'messaggio'),
								id: NotificationId.MESSAGE_VISIBLE_NOTIFICATION,
								title: ConfigProvider.APPLICATION_NAME,
								text: visibles.count + ' ' + ((visibles.count > 1) ? 'messaggi' : 'messaggio'),
								lockscreen: true,//visualizza il contenuto a schermo bloccato
								foreground: true,//solo per i test, invia la notifica anche on app in primo piano
								//launch: true, //rilancia l'app in primo piano
								//sound: isAndroid ? 'file://sound.mp3' : 'file://beep.caf',
								//data: { secret: key }
							});
						} else {
							console.debug('Notifiche non permesse');
						}
					});
				}
			}
			console.groupEnd()
		})
	}

	private clearAuthMessagePolling() {
		console.group('MessageProvider.clearAuthMessagePolling() : Disabilito eventuale polling di messaggi in arrivo..');

		if (this.authMessagesPollTimeout) {
			console.debug('MessageProvider.clearAuthMessagePolling() : Trovato polling attivo, lo elimino..');
			let timeout = this.authMessagesPollTimeout;//copia valore
			this.authMessagesPollTimeout = null;//annullamento e blocco indiretto del timeout
			clearTimeout(timeout);//eliminazione del timeout
		}

		console.groupEnd();
	}

	/**
	Elimina un messaggio
	*/
	public destroy(message: Message): Promise<boolean> {
		console.log("Eliminazione del messaggio:", message);
		let self = this;
		return new Promise<boolean>((resolve, _reject) => {
			let request = self.http.post(ConfigProvider.HOST + "/message/" + message.id + "/destroy", { confirm: true });
			request.subscribe(
				deleted => {
					if (!deleted) {//Chiamata ok ma non ha trovato il dispositivo
						console.warn("Messaggio non trovato: ", message);
						resolve(false);
						return;
					}
					resolve(true);
				}, error => {
					console.error("Errore eliminando il messaggio: ", error);
					//reject(error);
					resolve(false);
				}
			);
		});
	}

	/**
	Nasconde un messaggio, per il mittente o destinatario o entrambi
	*/
	public hide(message: Message): Promise<Message> {
		//let user = this.auth.user;
		if (!this.auth.canMessageHide(message)) {//qui verifica i permessi, dopo sa già che può procedere
			console.error('Permessi insufficienti per eseguire questa azione')
			return Promise.reject('Non puoi eseguire questa azione su questo messaggio');
		}

		if (!message) {
			console.error('Messaggio nullo, impossibile eseguire update');
			return Promise.reject('Messaggio nullo: Impossibile persisterlo');
		}
		if (!message.id) {
			console.error('Messaggio non ancora creato o ID mancante', message);
			return Promise.reject('Messaggio non associabile ad uno esistente');
		}

		/*
		let params = new HttpParams();

		switch (message.receiver_type) {
		case 'App\\Condominium'://Messaggio a bacheca, da utente
		console.debug('[MessageProvider.hide()] Messaggio a bacheca da utente amministratore')

		//nasconde per mittente e destinatario
		params = params.append('is_hidden_to_receiver', true.toString());
		params = params.append('is_hidden_to_sender', true.toString());
		break;
		case 'App\\User'://Messaggio a utente, da citofono o segnalazione
		console.debug('[MessageProvider.hide()] Messaggio a utente, da citofono, segnalazione bacheca o privato')

		//nasconde per l'utente corrente, lascia invariato l'altro
		if (message.receiver_type == 'App\\User' && message.receiver_id == this.auth.id) {
		params = params.append('is_hidden_to_receiver', true.toString());
	}
	if (message.sender_type == 'App\\User' && message.sender_id == this.auth.id) {
	params = params.append('is_hidden_to_sender', true.toString());
	}
	break;
	}

	console.debug('[MessageProvider.update()] Parametri hide:', params);
	*/
		let self = this;
		return new Promise<Message>((resolve, reject) => {
			let request = self.http.get<Message>(ConfigProvider.HOST + '/message/' + message.id + '/hide'/*, params*/);
			request.subscribe(
				message => {
					if (!message || !message.id || !(message.is_hidden_to_receiver || message.is_hidden_to_sender)) {//Chiamata ok ma non ha trovato il messaggio
						console.warn("Archiviazione del messaggio fallita", message);
						reject("Archiviazione del messaggio fallita");
						return;
					}
					console.debug("[MessageProvider.hide()] Messaggio archiviato", message);

					self.init(message);
					resolve(message);
				}, error => {
					console.error("Errore archiviando il messaggio", error);
					reject(error);
				}
			);
		});
	}



	/*
	Responsabilità: Recupera una sequenza di messaggi, eventualmente la inizializza e restituisce la promise per risolverla
	Requisiti: può essere usato con qualunque url che restituisca una sequenza di messaggi
	*/
	private index(
		url: string,
		method: string = 'GET',
		loads: string[] = [],
		params: HttpParams = null,
		before: Message = null,
		after: Message = null,
		pagesize: number = null,
	): Promise<Message[]> {
		if (params == null) {
			params = new HttpParams();
		}

		if (loads && loads.length > 0) {//aggiunge eventuali relazioni da caricare
			for (let load of loads) {
				params = params.append('loads[]', load);
			}
		}


		if (before) {//precedenti a questo
			params = params.set('before', before.id.toString());
		}

		if (pagesize) {//numero massimo di risultati
			params = params.set('pagesize', pagesize.toString());
		}

		if (after) {//dopo di questo
			params = params.set('after', after.id.toString());
		}

		console.debug('[MessageProvider.index()] Recupero i messaggi dalla URL: ' + url, params);

		let request: Observable<Message[]> = null;
		let self = this;

		switch (method) {
			case 'GET':
				request = this.http.get<Message[]>(url, { params: params });
				break;
			case 'POST':
				request = this.http.post<Message[]>(url, params);
				break;
			default:
				console.error("Metodo HTTP non riconosciuto: " + method);
				break;
		}

		return new Promise<Message[]>((resolve, reject) => {
			request.subscribe(
				messages => {
					if (!messages) {//Chiamata ok ma non ha trovato l'utente
						console.warn("Messaggi non trovati tramite URL: " + url);
						resolve(messages);
						return;
					}

					for (let message of messages) {
						self.init(message);
					}

					resolve(messages);
				}, error => {
					console.warn("Errore recuperando i messaggi da URL: " + url, error);
					reject(error);
				});
		});
	}

	public indexAll(
		id: number,
		type: MessageReceiverType,
		loads: string[] = null,
		pagesize: number = 10,
		before: Message = null,
		after: Message = null
	): Promise<Message[]> {
		console.debug('[MessageProvider.indexAll()] Recupero dei messaggi inviati e in arrivo per il tipo: ' + type, { id: id, type: type, pagesize: pagesize, before: before, after: after });

		let url = ConfigProvider.HOST + "/message/" + type + "/" + id;
		return this.index(url, 'GET', loads, null, before, after, pagesize);
	}


	/**
	Messaggi in arrivo epr un certo tipo di soggetto
	*/
	public indexIncoming(
		id: number,
		type: MessageReceiverType,
		loads: string[] = [],
		pagesize: number = 10,
		before: Message = null,
		after: Message = null
	): Promise<Message[]> {
		console.debug('[MessageProvider.indexIncoming()] Recupero dei messaggi in arrivo:', id, type, loads, pagesize, before, after, pagesize);

		let url = ConfigProvider.HOST + "/message/" + type + "/" + id + "/incoming";
		return this.index(url, 'GET', loads, null, before, after, pagesize);
	}

	/**
	Messaggi inviati dall'utente
	*/
	public indexSent(
		loads: string[] = [],
		pagesize: number = 10,
		before: Message = null,
		after: Message = null
	): Promise<Message[]> {
		console.log('Recupero dei messaggi inviati da questo utente:', loads, pagesize, before, after);

		let url = ConfigProvider.HOST + "/message/sent";
		return this.index(url, 'GET', loads, null, before, after, pagesize);
	}


	/**
	Responsabilità: Eventuali inizializzazioni post caricamento
	*/
	private init(_message: Message) {

	}

	/**
	Imposta un messaggio come letto
	*/
	public read(message: Message): Promise<Message> {
		//let user = this.auth.user;
		if (!this.auth.canMessageShow(message)) {//qui verifica i permessi, dopo sa già che può procedere
			console.error('Permessi insufficienti per eseguire questa azione')
			return Promise.reject('Non puoi eseguire questa azione su questo messaggio');
		}

		if (!message) {
			console.error('Messaggio nullo, impossibile eseguire update');
			return Promise.reject('Messaggio nullo: Impossibile persisterlo');
		}
		if (!message.id) {
			console.error('Messaggio non ancora creato o ID mancante', message);
			return Promise.reject('Messaggio non associabile ad uno esistente');
		}

		let self = this;
		return new Promise<Message>((resolve, reject) => {
			let request = self.http.get<Message>(ConfigProvider.HOST + '/message/' + message.id + '/read');
			request.subscribe(
				message => {
					if (!message || !message.id || !(message.is_hidden_to_receiver || message.is_hidden_to_sender)) {//Chiamata ok ma non ha trovato il messaggio
						console.warn("Lettura del messaggio fallita", message);
						reject("Lettura del messaggio fallita");
						return;
					}
					console.debug("[MessageProvider.read()] Messaggio segnato come letto", message);

					self.init(message);
					resolve(message);
				}, error => {
					console.error("Errore segnando il messaggio come letto", error);
					reject(error);
				}
			);
		});
	}

	/**
	Attiva il con trollo periodico dei messaggi per l'utente corrente
	*/
	public registerAuthMessagePolling() {
		//console.log('ClientApp.registerAuthMessagePolling() : Registrazione polling per nuovi messaggi in arrivo');
		let self = this;
		if (!self.auth) {
			console.error('Richiesto polling messaggi senza auth provider')
		}

		self.authMessagesPollTimeout = setTimeout(() => {
			console.debug('MessageProvider.registerAuthMessagePolling() : Poll nuovi messaggi..');
			if (self.authMessagesPollTimeout) {//Se null polling annullato o doppio polling accavallato
				try {//nessuna eccezione deve bloccare il flusso, alla fine verà registrato il nuovo poll
					self.authMessagesPollTimeout = null;//blocca eventuali altri timeout
					let user = self.auth.user;
					if (user && user.id) {
						let lastMessage: Message = null;
						let hasPreviousMessages = user.messages && user.messages.length > 0;
						if (hasPreviousMessages) {
							//console.debug('Trovati localmente messaggi già ricevuti:', user.messages);
							lastMessage = user.messages.reduce((min, actual) => actual.id > min.id ? actual : min, user.messages[0]);//l'ultimo
							//console.debug('Ultimo messaggio ricevuto:', lastMessage);
						}

						//console.debug('Richiesta dei nuovi messaggi in arrivo..');
						self.indexIncoming(user.id, MessageReceiverType.USER, ['condominium'], 20, null, lastMessage).then((messages: Message[]) => {
							//console.debug('ClientApp.messages.indexUserAll().then() : Ricercati messaggi in arrivo')
							if (messages && messages.length > 0) {
								//console.debug('Trovati nuovi messaggi:', messages);

								if (self.devices.isBrowser)/*self.platform.is('core') || self.platform.is('mobileweb')*/ {
									console.debug('MessageProvider.registerAuthMessagePolling() : Browser: Uso le notifiche browser')
									// Let's check if the browser supports notifications
									if (!("Notification" in window)) {
										console.warn("Questo browser non supporta le notifiche");
									}

									Notification.requestPermission().then(_result => {
										try {
											let title = ConfigProvider.APPLICATION_NAME + ': ' + messages.length + ' ' + ((messages.length > 1) ? 'nuovi messaggi' : 'nuovo messaggio');
											var options = {
												//body: body,
												//icon: icon
											};
											var n = new Notification(title, options);
											n.onclick = _event => {
												//Va al pannello di controllo
												//self.nav.goToRoot({});//Torna alla root attualmente configurata
												self.devices.moveToForeground()
											};
										} catch (e) {
											console.error('Errore attivando la notifica', e);
										}
									});
								} else {
									console.debug('MessageProvider.registerAuthMessagePolling() : App: uso le notifiche native')

									let nativeNotifications = [];
									let groupName = ConfigProvider.NOTIFICATION_CHANNEL_NEWMESSAGE + '-' + messages[0].id;

									self.localNotifications.requestPermission().then(can => {
										if (can) {
											for (let message of messages) {
												let text;
												if (message.sender && message.sender_type == 'App\\User') {
													let sender = <User>message.sender;
													text = [{
														person: sender.name + ' ' + sender.surname,
														message: message.subject
													}];
												} else {
													text = message.subject
												}

												nativeNotifications.push({
													channel: ConfigProvider.NOTIFICATION_CHANNEL_NEWMESSAGE,
													group: groupName,//raggruppa se hanno lo stesso id
													groupSummary: true,
													summary: ConfigProvider.APPLICATION_NAME + ': ' + messages.length + ' ' + ((messages.length > 1) ? 'nuovi messaggi' : 'nuovo messaggio'),
													id: message.id,
													title: ConfigProvider.APPLICATION_NAME + ': Nuovo messaggio',
													text: text,
													lockscreen: true,//visualizza il contenuto a schermo bloccato
													foreground: true,//solo per i test, invia la notifica anc he on app in primo piano
													//launch: true, //rilancia l'app in primo piano
													//sound: isAndroid ? 'file://sound.mp3' : 'file://beep.caf',
													//data: { secret: key }
												});
											}

											if (nativeNotifications.length > 0) {
												self.localNotifications.schedule(nativeNotifications);
											}
										} else {
											console.debug('Notifiche non permesse');
										}
									});
								}


								if (hasPreviousMessages) {
									user.messages = messages.concat(user.messages);
									//TODO valutare se ordinare i messaggi letti per data di invio
								} else {
									user.messages = messages;
								}
							} else {
								//console.debug('Nessun nuovo messaggio.')
							}
						}).catch(error => {
							console.error("Errore recuperando i messaggi dell'utente: " + error.message, error);
						})
					} else {//non era autenticato, stop
						console.warn('Schedulata ricerca mesaggi ma utente non autenticato, deregistro il controllo messaggi');
						self.clearAuthMessagePolling();
					}
				} catch (e) {
					//se è già dismesso lancia eccezione, ignora
					console.error('Errore durante il polling di nuovi messaggi: ' + e.message, e);
				}

				self.registerAuthMessagePolling();//schedulazione nuovo polling
			}
		}, this.authMessagesPollTime);
	}


	/*
	Invia un messaggio a un condominio
	*/
	public sendToCondominium(
		to: Condominium,
		body: string,
		subject: string,
		visibility: MessageVisibility = MessageVisibility.PRIVATE,
		priority: MessagePriority = MessagePriority.NORMAL,
		pinUntil: Date = null,
		answered: Message//Messaggio a cui si risponde
	): Promise<Message> {
		console.debug('Invio messaggio al condominio:', {
			to: to,
			body: body,
			subject: subject,
			visibility: visibility,
			priority: priority,
			answered: answered
		})
		let self = this;
		return new Promise<Message>((resolve, reject) => {
			let threadId: number = null;
			if (answered) {
				if (answered.thread_id) {
					threadId = answered.thread_id
				} else {
					threadId = answered.id
				}
			}
			self.store(
				'Condominium',
				to.id,
				body,
				subject,
				visibility,
				priority,
				pinUntil,
				to.id,
				null,
				threadId
			).then((messages: Message[]) => {
				if (messages.length == 0) {
					console.warn("Nessun messaggio restituito dall'invio");
					resolve(null);
					return;
				}
				resolve(messages[0]);
			}).catch(error => {
				reject(error);
			});
		});
	}

	/*
	Invia un messaggio a una unità abitativa
	*/
	public sendToHousingUnit(to: HousingUnit, body: string, subject: string, answered: Message = null, contentType = MessageType.TEXT, attachmentPath: string = null): Promise<Message> {
		let self = this;

		return new Promise<Message>((resolve, reject) => {
			let threadId = null;
			if (answered) {
				if (answered.thread_id) {
					threadId = answered.thread_id
				} else {
					threadId = answered.id
				}
			}
			self.store(
				'HousingUnit',
				to.id,
				body,
				subject, MessageVisibility.PRIVATE,
				MessagePriority.NORMAL,
				null,
				to.condominium_id,
				to.id,
				threadId,
				contentType,
				attachmentPath
			).then((messages: Message[]) => {
				if (messages.length == 0) {
					console.warn("Nessun messaggio restituito dall'invio");
					resolve(null);
					return;
				}
				resolve(messages[0]);
			}).catch(error => {
				reject(error);
			});
		});
	}

	public sendToUser(
		to: User,
		body: string,
		subject: string,
		condominiumId: number = null,
		housingUnitId: number = null,
		answered: Message
	): Promise<Message> {
		let self = this;
		return new Promise<Message>((resolve, reject) => {
			let threadId: number = null;
			if (answered) {
				if (answered.thread_id) {
					threadId = answered.thread_id
				} else {
					threadId = answered.id
				}
			}
			self.store(
				'User',
				to.id,
				body,
				subject,
				MessageVisibility.PRIVATE,
				MessagePriority.NORMAL,
				null,
				condominiumId,
				housingUnitId,
				threadId
			).then(messages => {
				resolve(messages[0]);
			}).catch(error => {
				reject(error);
			});
		});
	}
	/*
	Invia un messaggio a più utenti
	*/
	public sendToUsers(tos: User[], body: string, subject: string, condominiumId: number = null, housingUnitId: number = null): Promise<Message[]> {
		let toIds = [];
		for (let to of tos) {
			toIds.push(to.id);
		}
		return this.store(
			'User',
			toIds,
			body,
			subject,
			MessageVisibility.PRIVATE,
			MessagePriority.NORMAL,
			null,
			condominiumId,
			housingUnitId
		)
	}

	/**
	Invia un messaggio a uno o più utenti contemporaneamente
	Accetta opzionalmente subject, mittente e visibilità (applicabile solo se il destinatario è un condominio)
	Se il mittente non è specificato, usa l'utente autenticato se disponibile
	*/
	private store(
		type: string,
		tos: number[] | number,
		body: string,
		subject: string = null,
		visibility: MessageVisibility = MessageVisibility.PRIVATE,
		priority: MessagePriority = MessagePriority.NORMAL,
		pinUntil: Date = null,
		condominiumId: number = null,
		housingUnitId: number = null,
		threadId: number = null,
		messageType: MessageType = MessageType.TEXT,
		attachmentPath: string = null
	): Promise<Message[]> {
		console.debug('MessageProvider.store() :', {
			type: type,
			tos: tos,
			body: body,
			subject: subject,
			visibility: visibility,
			priority: priority,
			pinUntil: pinUntil,
			condominiumId: condominiumId,
			housingUnitId: housingUnitId,
			threadId: threadId,
			messageType: messageType,
			attachmentPath: attachmentPath,
		});
		let self = this;

		return new Promise<Message[]>((resolve, reject) => {
			let rawParams: any = {};

			rawParams.body = body;

			if (visibility) {
				rawParams.visibility = visibility;
			}
			if (priority) {
				rawParams.priority = priority;
			}
			if (pinUntil) {
				rawParams.pin_until = pinUntil.toISOString().split('T')[0];
			}
			if (condominiumId) {
				rawParams.condominium_id = condominiumId.toString();
			}
			if (housingUnitId) {
				rawParams.housing_unit_id = housingUnitId.toString();
			}
			if (threadId) {
				rawParams.thread_id = threadId.toString();
			}
			if (messageType) {
				rawParams.type = messageType.toString();
			}
			if (subject) {
				rawParams.subject = subject;
			}


			if (messageType == MessageType.AUDIO && attachmentPath) {//invio file
				var filename = attachmentPath.substring(attachmentPath.lastIndexOf('/') + 1);
				const fileTransfer: FileTransferObject = this.fileTransfer.create();

				let options: FileUploadOptions = {
					fileKey: 'attachment',
					fileName: filename,
					headers: {
						//contentType: "application/json; utf-8"
						"Accept": "application/json"
					},
					params: rawParams,
					mimeType: 'audio/3gpp',//TODO Android usa 3gp, altri usano altri formati
				}
				fileTransfer.upload(attachmentPath, ConfigProvider.HOST + "/message/" + type + '/' + tos + "/store", options).then((answer) => {
					if (answer.responseCode != 200) {//doppio controllo errore, anche con il codice
						console.error("Codice errore inviando l'audiomessaggio: ", answer);
						reject("Errore inviando l'audiomessaggio")
					}
					let messages = JSON.parse(answer.response);
					console.debug('[MessageProvider.store().fileTransfer.upload().then()] File inviato, risposta: ', messages)
					resolve(messages[0]);
				}).catch(e => {
					console.error("Errore inviando l'audiomessaggio: ", e);
					reject("Errore inviando l'audiomessaggio")
				})
			} else {

				//let params = new HttpParams();

				//mappo i parametri in HttpParams
				let params = Object.getOwnPropertyNames(rawParams).reduce((p, key) => p.set(key, rawParams[key]), new HttpParams());
				/*
			params = params.set('body', body);

			if (visibility) {
				params = params.set('visibility', visibility);
			}
			if (priority) {
				params = params.set('priority', priority);
			}
			if (pinUntil) {
				params = params.set('pin_until', pinUntil.toISOString().split('T')[0]);
			}
			if (condominiumId) {
				params = params.set('condominium_id', condominiumId.toString());
			}
			if (housingUnitId) {
				params = params.set('housing_unit_id', housingUnitId.toString());
			}
			if (threadId) {
				params = params.set('thread_id', threadId.toString());
			}
			if (messageType) {
				params = params.set('type', messageType.toString());
			}
			if (subject) {
				params = params.set('subject', subject);
			}
			*/


				/*id destinatari, come parametro se multipli altrimenti nella URL*/
				if (tos instanceof Array) {
					for (let to of tos) {
						params = params.append('tos[]', to.toString());
					}
				} else {
					//aggiunge l'id in url
					type = type + '/' + tos
				}
				let request = self.http.post(ConfigProvider.HOST + "/message/" + type + "/store", params);
				request.subscribe((messages: Message[]) => {
					resolve(messages);
				}, error => {
					console.error("Errore inviando i messaggi: ", error);
					reject(error);
				});
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/providers/message/message.ts